<template>
  <div class="footer-view">
    <div class="footer-foot">
      <div class="foot-left">
        BMW悦学苑(BMW JOY LEARNING)是BMW授权经销商员工的学习发展平台。<br />
        我们将持续提供优质的培训辅导课程，帮助您获得全新的个人发展和能力提升。
      </div>
      <div class="foot-left">
        客服热线：400-024-7666<br />
        客服邮箱：<a>BMW.CallCenter@bmw-brilliance.cn</a>
      </div>
      <div class="foot-left">
        个人法律声明<br />
        BMW JOY LEARNING @2020 版权所有
      </div>
      <div class="foot-right">
        <div style="width:205px;margin:0 auto; padding:13px 0;">

          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502038527" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img alt="" src="@/assets/img/PSB_icon.png" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">京公网安备 11010502038527号</p></a>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-view {
  font-size: 12px;
  line-height: 16px;
  border: 2px solid #e9e9e9;
  border-bottom: 0px;
  border-left: 0px;
  border-right: 0px;
  .footer-content {
    width: 90%;
    margin: 0 auto;
    height: 150px;
    padding: 0px;
    .content-line {
      height: 40px;
      margin-top: 15px;
      padding-top: 10px;
      .content-left {
        width: auto;
        float: left;
      }
      .content-right {
        margin-left: 35px;
        float: left;
      }
    }
  }
  .footer-foot {
    width: 1200px;
    margin: 0 auto;
    height: 80px;
    .foot-left {
      margin-top: 25px;
      width: auto;
      float: left;
      margin-right: 5px;
    }
    .foot-right {
      margin-top: 25px;
      float: right;
    }
    .foot-center{
      margin:auto;
    }
  }
}
</style>
